import { Moment } from 'moment-timezone';

export const getNumberOfNights = (fromDate: Moment, toDate?: Moment | null): number =>
  (toDate ?? fromDate.clone().add(1, 'days')).diff(fromDate, 'days');
